import React from "react"
import { Col, Form } from "react-bootstrap"
import "react-datepicker/dist/react-datepicker.css"
import PollutionOnly from "./PollutionOnly"
import PollutionAndProfessional from "./PollutionAndProfessional"

const CoverageRequested = ({ applicationData, updateApplication, validationError, priorPolicy, isRenewal }) => {
    return (
        <React.Fragment>
            <Form>
                <Form.Group
                    as={Col}
                    md={6}>
                    <Form.Label>Please check the box below that applies to the coverage you are seeking.</Form.Label>
                    <Col>
                        <Form.Check
                            type="radio"
                            label="Contractor Pollution Liability Coverage Only"
                            name="contractorPollutionLiabilityCoverageOnly"
                            value="pollutionOnly"
                            checked={applicationData?.contractorPollutionLiabilityCoverageOnly === true}
                            onChange={updateApplication}
                        />
                        <Form.Check
                            type="radio"
                            label="Contractor Pollution Liability and Professional Liability Coverage"
                            name="contractorPollutionLiabilityAndProfessionalLiabilityCoverage"
                            value="pollutionAndProfessional"
                            checked={
                                applicationData?.contractorPollutionLiabilityAndProfessionalLiabilityCoverage === true
                            }
                            onChange={updateApplication}
                        />
                    </Col>
                    {validationError?.coverageRequested && (
                        <div className="text-error">Please select the coverage you are seeking.</div>
                    )}
                </Form.Group>
            </Form>
            {applicationData?.contractorPollutionLiabilityCoverageOnly && (
                <PollutionOnly
                    applicationData={applicationData}
                    isRenewal={isRenewal}
                    updateApplication={updateApplication}
                    validationError={validationError}
                />
            )}
            {applicationData?.contractorPollutionLiabilityAndProfessionalLiabilityCoverage && (
                <PollutionAndProfessional
                    applicationData={applicationData}
                    priorPolicy={priorPolicy}
                    updateApplication={updateApplication}
                    validationError={validationError}
                />
            )}
        </React.Fragment>
    )
}

export default CoverageRequested
